// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ReportActions } from '../duck';
import ReportModal from '../components/ReportModal';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isReporting: state.report.isReporting,
    reportError: state.report.reportError,
    reportSuccess: state.report.reportSuccess,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...ReportActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportModal);



// WEBPACK FOOTER //
// ./src/modules/report/container/ReportModalContainer.js